let apiUrl = process.env.VUE_APP_API_URL;


class TravelDistanceApi {

    getListByFloorPlanId(id){
        var url = apiUrl + `travelDistances?floorPlanId=${id}`;
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });

    }

    getList() {
        var url = apiUrl + 'travelDistances';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'travelDistances/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }
 
    create(data) {
        var url = apiUrl + 'travelDistances';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(id, data) {
        var url = apiUrl + 'travelDistances/';
        return api.call('patch', url + id, data)
            .then(({ data }) => {
                return data
            });
    }
    updateData(id, data) {
        var url = apiUrl + 'travelDistances/';
        return api.call('patch', url + id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'travelDistances/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

}

export default TravelDistanceApi;